import { deriveResource } from 'pulse/resources';
import { keyBy } from '../../utils/keyBy';
import { PropertyGroups } from '../PropertyGroups';
import { stringCollator } from '../../utils/stringCollator';
export const PropertyDefinitions = deriveResource('hs-resources:PropertyDefinitions').from(PropertyGroups).pull(({
  other
}) => other.data.flatMap(group => {
  var _group$propertyDefini;
  return (_group$propertyDefini = group.propertyDefinitions) !== null && _group$propertyDefini !== void 0 ? _group$propertyDefini : [];
}).sort((a, b) => stringCollator.compare(a.property.label || a.property.name, b.property.label || b.property.name))).push(({
  self,
  other
}) => {
  if (other.data) {
    const propertiesMap = keyBy(self.data, definition => definition.property.groupName, (definition, __index, props = []) => {
      props.push(definition);
      return props;
    });
    for (const group of other.data) {
      group.propertyDefinitions = propertiesMap[group.name];
    }
  }
}).register();
export const PropertyDefinitionsMap = deriveResource('hs-resources:PropertyDefinitionsMap').from(PropertyDefinitions).pull(({
  other
}) => keyBy(other.data, definition => definition.property.name)).push(({
  self
}) => Object.values(self.data)).register();
export const PropertyDefinition = deriveResource('hs-resources:PropertyDefinition').from(PropertyDefinitionsMap).mapParams(({
  objectTypeId,
  showHighlySensitiveProperties
}) => ({
  objectTypeId,
  showHighlySensitiveProperties
})).mergeArgs(['propertyName']).pull(({
  self,
  other
}) => {
  const property = other.data[self.params.propertyName];
  if (!property) {
    throw new Error(`Property ${self.params.propertyName} not found`);
  }
  return property;
}).push(({
  self,
  other
}) => {
  if (other.data) {
    other.data[self.params.propertyName] = self.data;
  }
}).register();